import type {
  WorkplaceRequestOccupiedResourceAction,
  WorkplaceRequestReleasedResourceAction,
  WorkplaceRequestWorkflowOverrides
} from "@gettactic/api";

/**
 * The approver's desk choices as core wants them: one override per rule,
 * carrying only the keys the approver actually changed. A rule the approver
 * also skipped is dropped, because core rejects a body that both skips and
 * overrides the same rule, and skipping is the stronger statement.
 */
export const buildDeskWorkflowOverrides = (
  released: Record<string, WorkplaceRequestReleasedResourceAction>,
  occupied: Record<string, WorkplaceRequestOccupiedResourceAction>,
  skippedWorkflowIds: string[]
): WorkplaceRequestWorkflowOverrides => {
  const workflowIds = new Set([
    ...Object.keys(released),
    ...Object.keys(occupied)
  ]);
  return Object.fromEntries(
    [...workflowIds]
      .filter((workflowId) => !skippedWorkflowIds.includes(workflowId))
      .map((workflowId) => [
        workflowId,
        {
          ...(released[workflowId]
            ? { released_resource_action: released[workflowId] }
            : {}),
          ...(occupied[workflowId]
            ? { occupied_resource_action: occupied[workflowId] }
            : {})
        }
      ])
  );
};
